import moment from 'moment';
import { FC, useState } from 'react';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import { ButtonArea } from '../../../../../shared/button-area/button-area';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../../shared/dialog/dialog.styles';
import { CreatePayerSetupWizardLink } from '../../../../shared/utils/iv-deep-link';
import { withPatientIvStatusDialogProvider } from '../../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../../shared/appointment-ended-message/appointment-ended-message';
import { InsuranceInfo } from '../../shared/insurance-info/insurance-info';
import { ManuallyVerifiedButton } from '../../shared/manually-verified-button';
import { RunVerificationButton } from '../../shared/run-verification-button';
import { SelfPayButton } from '../../shared/self-pay-button';
import { BoldText } from '../../styles';

const RELATIONSHIPS_PAGE_ID = 101;

const ProviderRelationshipInvalidStatusDialog: FC = () => {
  const { publish } = useEventBus();
  const { opened, onClose, isLoading, locationId, patientInfo, getProvider, selectedIvSummary, appointment } =
    usePatientIvStatusDialog();
  const [provider] = useState(getProvider(selectedIvSummary?.idProvider));

  const onUpdateProviderRelationClick = async () => {
    if (!selectedIvSummary?.idCarrierName) {
      console.error('Carrier Name ID is missing');

      return;
    }

    publish({
      messageType: 'navigate',
      data: {
        ...CreatePayerSetupWizardLink(locationId, selectedIvSummary?.idCarrierName, RELATIONSHIPS_PAGE_ID),
        crossFrame: true
      }
    });
    onClose();
  };

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateReceived && (
            <>&nbsp;- Run {moment.utc(selectedIvSummary.dateReceived).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        The provider relationship between {provider ? provider.name : 'Current Provider'}&nbsp; and{' '}
        {selectedIvSummary?.idPayer} has returned as "invalid".
        <br />
        <br />
        Please confirm the relationship and correct the issue to rerun the verification process. Alternatively, you may
        manually verify the patient or designate them as self-pay.
      </DialogSubTitle>
      <br />
      <ButtonArea
        title="Fix Now"
        buttons={[{ title: 'Update Provider Relation', onClick: onUpdateProviderRelationClick }]}
      />
      {patientInfo && <InsuranceInfo patientInfo={patientInfo} />}
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <RunVerificationButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(ProviderRelationshipInvalidStatusDialog);
